import React from 'react';
import { Container } from '@mui/material';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import Topbar from 'src/components/topbar';
import Stepper from 'src/components/stepper';

// booking flow steps and paths
export const stepsConfig = [
  { label: 'Questions 1', path: '/survey/question_1' },
  { label: 'Questions 2', path: '/survey/question_2' },
  { label: 'Questions 3', path: '/survey/question_3' },
  { label: 'Questions 4', path: '/survey/question_4' }
];

function SurveyLayout({ withoutStepper, children }) {
  const location = useLocation();

  const currentIndex = stepsConfig.findIndex(step =>
    location.pathname.startsWith(step.path)
  );

  return (
    <>
      <Topbar />
      <Container>
        {!withoutStepper && (
          <Stepper
            steps={stepsConfig?.map(step => step.label)}
            currentStep={currentIndex + 1}
          />
        )}

        {children}
      </Container>
    </>
  );
}

SurveyLayout.propTypes = {
  children: PropTypes.node.isRequired,
  withoutStepper: PropTypes.bool
};

SurveyLayout.defaultProps = {
  withoutStepper: false
};

export default SurveyLayout;
